import axios from 'axios';

const api = axios.create({
  baseURL: 'https://interactionez.ro',
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true // This is important for CORS with credentials
});

export const submitAnnualTaxForm = (data) => {
  return api.post('/submitAnnualTaxForm', data);
};

// Save form data to WordPress (for 3.5% annual tax form)
export const saveFormData = (data) => {
  return axios.post('/wp-content/themes/recorder/template-parts/formular/saveAnnualTaxForm.php', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const sendDonationEmail = (data) => {
  return axios.post('/wp-content/themes/recorder/template-parts/formular/sendMailDonatie35.php', data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  });
};

// Log frontend errors to backend
export const logFrontendError = (errorType, errorMessage, errorDetails = {}, formData = null) => {
  try {
    const errorData = {
      errorType,
      errorMessage,
      errorDetails: {
        ...errorDetails,
        // Add browser info
        userAgent: navigator.userAgent,
        url: window.location.href,
        timestamp: new Date().toISOString()
      },
      // Include form data if provided (will be sanitized on backend)
      formData: formData || null
    };
    
    // Try to log, but don't fail if it doesn't work
    return api.post('/logFrontendError', errorData).catch(err => {
      // Silently fail - don't break the app if error logging fails
      console.warn('Failed to log frontend error to server:', err);
    });
  } catch (err) {
    // Silently fail
    console.warn('Failed to prepare frontend error log:', err);
  }
};
